import React, { useEffect, useRef } from "react";

import { css } from "@emotion/react";

import { ReactTFC } from "../../../utils/fp/missing-ts-parts";
import { CSS_MQ } from "../../../styles/breakpoints";
import { AspectRatio } from "../../_shared-components/image-related/AspectRatio";
import { ProductClickAndInfoType } from "@swo/storefront";
import { ContentfulImage } from "../../_shared-components/image-related/ContentfulImage";
import { SwarovskiOptikVideoPlayer } from "../../VideoComponent/VideoComponent";

export const ClickAndInfoMedia: ReactTFC<{
  media: ProductClickAndInfoType["hotSpotsCollection"][0]["media"];
  isActive: boolean;
}> = props => {
  return (
    <AspectRatio height={2} width={3} attachStyles={imageWrapperStyles}>
      {props.media.__typename === "UtilityVideo" ? (
        <SwarovskiOptikVideoPlayer
          video={props.media.video}
          subtitles={props.media.subtitles}
          sharedVideoProps={{
            muted: true,
            autoPlay: props.isActive,
            crossOrigin: "crossorigin" as any,
            loop: true,
            preload: "auto",
            playsInline: true,
          }}
          resolutionPickerStrategy={"middle"}
          wrapperClassName={"visible"}
          css={css`
            height: 100%;
            max-width: 100%;
            background: black;
          `}
          portraitMode={false}
          withPlayerUI={false}
          sys={{ id: "" }}
          mode={"fill"}
        />
      ) : (
        <ContentfulImage
          assetId={props.media.image.sys.id}
          className={"slide-in-left"}
          css={imageStyles}
          contentfulLink={{
            url: props.media.image.url,
            noTransparentBackground: false,
            requestedWidth: 600,
          }}
        />
      )}
    </AspectRatio>
  );
};

const imageWrapperStyles = css`
  margin-bottom: 44px;
  line-height: 0;

  ${CSS_MQ.atMostSm} {
    margin-bottom: 30px;
    margin-left: -20px;
    margin-right: -20px;
  }
`;

const imageStyles = css`
  overflow: hidden;

  width: 100%;
  height: 100%;
  object-fit: cover;
  object-position: center;
`;
